import { API } from '../api';
import { camelCaseKeys } from '../keys';
import { logError } from '../log';
import { getAccessToken } from '../token';


import {
  ServerSideEvent,
  ServerSideEventType,
  Subscriber
} from './types';

let source: null | EventSource = null;
const subscribers: Array<[ServerSideEventType, Subscriber]> = [];

const eventListener = event => {
  try {
    const data: null | ServerSideEvent = (camelCaseKeys(JSON.parse(event.data)) as any);

    if (data === null) {
      return;
    }

    subscribers.forEach(subscriber => {
      if (subscriber[0] === data.type) {
        subscriber[1](data.data);
      }
    });
  } catch (error) {
    logError(error);
  }
};

export const subscribe = (type: ServerSideEventType, subs: Subscriber): void => {
  const accessToken = getAccessToken();

  subscribers.push([type, subs]);

  const errorListener = error => {
    logError(error);
    if (source) {
      source.close();
      source = null;
    }

    if (!document.hidden) {
      setTimeout(() => {
        subscribe(type, subs);
      }, 5000);
    }
  };

  if (source === null && accessToken) {
    source = new EventSource(
      API.END_POINTS.SSE.getSSEEndpointURL(accessToken)
        .replace(/http(s?):\/\//, '')
    );

    source.addEventListener('error', errorListener);
    source.addEventListener('sse-event', eventListener);
  }
};

export const unsubscribe = (type: ServerSideEventType, subs: Subscriber): void => {
  const index = subscribers.findIndex(
    subscriber => subscriber[0] === type && subscriber[1] === subs
  );

  if (index > -1) {
    subscribers.splice(index, 1);
  }

  if (subscribers.length === 0 && source) {
    source.removeEventListener('sse-event', eventListener);
    source.close();
    source = null;
  }
};
